import { combineReducers } from 'redux';

// import login from '../pages/Login/redux/reducer.js';
import contributorExp from '../pages/ContributorExperience/redux/reducer.js';
// import contributer from '../pages/Contributor/redux/reducer.js';

// Sharath\
import home from '../pages/Home/redux/reducer.js';
import bookmark from '../components/bookmark/redux/reducer.js';
import eatery from '../pages/Eatery/redux/reducer.js';
import listicle from '../pages/Listicle/redux/reducer.js';
import story from '../pages/Story/redux/reducer.js';
import community from '../pages/Community/redux/reducer.js';
import experiences from '../pages/CulinaryExperience/redux/reducer.js';
import search from '../pages/Search/redux/reducer.js';
import landing from '../pages/Landing/redux/reducer.js';
import myDashboard from '../pages/MyDashboard/redux/reducer.js';

// Dheeraj
import eateryEditor from 'pages/EateryEditor/duck';
import storyEditor from 'pages/StoryEditor/duck';
import errorDialog from 'components/ErrorDialog/duck';
import entities from 'schemas/duck';

// Shivam
import addEditListicle from '../pages/AddEditListicle/redux/reducer.js';
import addEditContributor from '../pages/AddEditContributor/redux/reducer.js';
import listFollowers from '../pages/ListFollowers/redux/reducer.js';
import myBoards from '../pages/MyBoards/redux/reducer.js';

// Anit
import eateryLanding from '../pages/EateryLanding/redux/reducer.js';
import contributerDashboard from '../pages/ContributorDashboard/redux/reducer.js';
import userProfile from '../pages/UserProfileMobile/redux/reducer';

const reducer = combineReducers({
  ...eateryEditor,
  ...storyEditor,
  ...errorDialog,
  ...entities,
  contributorExp,
  contributerDashboard,
  home,
  eatery,
  listicle,
  story,
  community,
  experiences,
  search,
  bookmark,
  addEditListicle,
  addEditContributor,
  listFollowers,
  myBoards,
  eateryLanding,
  landing,
  userProfile,
  myDashboard
});

export default reducer;
